import React from 'react';
import { Col, Select, SelectProps } from 'antd';
import { ECommonEntityStatusText, ECommonEntityStatus } from 'entities/Bitecoin/Bitecoin.models';

interface IComponentProps {
  onChangeStatus: (value?: ECommonEntityStatus[]) => void;
}

type AllProps = SelectProps<any> & IComponentProps;

export const EntityStatusSelector: React.FC<AllProps> = ({ value, onChangeStatus }) => {
  const onChange = (value: ECommonEntityStatus[]) => {
    onChangeStatus(value);
  };

  return (
    <Col>
      <span>Status</span>
      <Select
        allowClear
        mode="multiple"
        className="width-full mt-3"
        placeholder="Select status"
        value={value}
        defaultActiveFirstOption={false}
        onChange={(value) => onChange(value)}
      >
        <Select.Option
          key={ECommonEntityStatus.Active}
          value={ECommonEntityStatus.Active}
          label={ECommonEntityStatusText.Active}
        >
          {ECommonEntityStatusText.Active}
        </Select.Option>
        <Select.Option
          key={ECommonEntityStatus.Inactive}
          value={ECommonEntityStatus.Inactive}
          label={ECommonEntityStatusText.Inactive}
        >
          {ECommonEntityStatusText.Inactive}
        </Select.Option>
        <Select.Option
          key={ECommonEntityStatus.Archived}
          value={ECommonEntityStatus.Archived}
          label={ECommonEntityStatusText.Archived}
        >
          {ECommonEntityStatusText.Archived}
        </Select.Option>
      </Select>
    </Col>
  );
};
